


























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Moment from "moment-timezone";
import PageRequest from "@/store/entities/page-request";
import { Row } from "view-design";

/**
* 分页数据
*/
class PageDeviceInfoRequest extends PageRequest {
    /**设备id */
    deviceId: string;
    /**设备类型 */
    deviceType: number;
}
/**信息实体类 */
class DataInfoDto {
    /**设备Id */
    deviceId: string;
    /**设备编号 */
    deviceNo: string;
    /**设备类型 */
    deviceType: number;
    /**组织 */
    organizationName: string;
    /**区域 */
    areaName: string;
    /**安装位置 */
    location: string;
    /**房号 */
    roomNo: string;
    /**最后读表数 */
    totalUse: string;
    /**最后上报时间 */
    lastReportTime: Date;
    /**安装时间 */
    installTime: Date;
}

@Component({
    components: {},
})
export default class ShowInfo extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: String, default: "" }) deviceId: string;
    @Prop({ type: Number, default: 0 }) deviceType: number;
    /**分页类 */
    pagerequest: PageDeviceInfoRequest = new PageDeviceInfoRequest();
    /**信息 */
    dataDto: DataInfoDto = new DataInfoDto();

    formatterTime(datestr: string) {
        return Moment(datestr).format("YYYY-MM-DD HH:mm:ss")
    }
    create() { }
    created() {

    }
    cancel() {
        this.$emit("input", false);
    }
    async getdatainfo() {
        await this.$store.dispatch({ type: 'meterinfo/deviceDataInfo', data: this.pagerequest }).then((data) => {
            if (data.status === 200 && data.data.success) {
                this.dataDto = data.data.result;
            } else {
                this.$Modal.error({
                    title: this.L("Tips"),
                    content: data.data.statusText,
                });
            }
        }).catch((error) => {
            console.log(error)
        })
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        }
        this.getdatainfo();
    }
    @Watch("deviceId", { deep: true })
    @Watch("deviceType", { deep: true })
    getitemId() {
        this.pagerequest.deviceId = this.deviceId;
        this.pagerequest.deviceType = this.deviceType;
    }
}
